import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from "@angular/router";
import {MultiLanguageService} from '@share/translate';
import {OneSignal} from 'onesignal-ngx';
import {AccountService} from '@core/services/account/account.service';
import {ContinueAsGuest} from '@core/models';
import {firstValueFrom} from 'rxjs';
import { LoadingService } from "@core/services/loading.service";
import { AsyncPipe, NgIf } from "@angular/common";
import { LoadingComponent } from "@core/components/loading/loading.component";
import { Meta, Title } from "@angular/platform-browser";
import { SeoService } from "@core/services/SeoService";
import { filter, map } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet, LoadingComponent, AsyncPipe, NgIf]
  //
})
export class AppComponent implements OnInit{
  isLoading$ = this.loadingService.isLoading$;
  constructor(
    private readonly lan: MultiLanguageService,
    private readonly loadingService: LoadingService,
    private oneSignal: OneSignal,
    private readonly accountService: AccountService,
    private seoService: SeoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: MultiLanguageService
  ) {
    this.oneSignal
      .init({
        appId: '3fc371a7-6744-4144-8d5d-7e85a33103b7',
        notifyButton: { enable: true },
        notificationClickHandlerAction: 'navigate',
        autoRegister: true,
        autoResubscribe: true,
        subdomainName: 'gopon',
        allowLocalhostAsSecureOrigin: true,
      })
      .then((r) => {
        //console.log('Onesignal initialized successfully');
      });
    this.oneSignal.on('subscriptionChange', (isSubscribed) => {
      //console.log("The user's subscription state is now:", isSubscribed);
      this.oneSignal.getUserId().then((data) => {
        localStorage.setItem('oTokenId', data ?? '');

        const body: ContinueAsGuest = new ContinueAsGuest();
        body.DeviceId = localStorage.getItem('uId') ?? '';

        body.DeviceToken = data ?? '';
        firstValueFrom(this.accountService.continueAsGuest(body)).then();
      });
    });
    this.oneSignal.on('notificationDismiss', function (event) {
      console.warn('OneSignal notification dismissed:', event);
    });
    this.oneSignal
      .addListenerForNotificationOpened((callback) => {
        console.warn('OneSignal notification clicked:', callback.data);
      })
      .then((data) => {});
    this.isLoading$.subscribe((res) => {});
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.next(true);
        return;
      }
      if (event instanceof NavigationEnd) {
        this.loadingService.next(false);
        return;
      }
      if (event instanceof NavigationCancel) {
        this.loadingService.next(false);
        return;
      }
      if (event instanceof NavigationError) {
        this.loadingService.next(false);
        return;
      }
    });
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child?.firstChild) {
          child = child.firstChild;
        }
        return child?.snapshot.data;
      })
    ).subscribe((data: any) => {
      const title = data?.title || this.translate.instant("home_page_title");
      const description = data?.description || this.translate.instant("home_page_description")  ;

      this.seoService.updateMeta(title, description);
    });
  }
}
